import { createActions } from 'redux-actions';

import { UpdateUserPasswordParams } from '@apis/UserPasswordApi';

export type State = {
  isSuccess: boolean;
  serverErrors: object;
};

export type UpdatePasswordPayload = UpdateUserPasswordParams;
export type StateUpdatePayload = Partial<State>;

export const {
  passwordUpdate,
  stateUpdate,
} = createActions(
  'PASSWORD_UPDATE',
  'STATE_UPDATE',
  {
    prefix: 'PASSWORD',
  },
);
